import React, { useRef } from "react";
import { Dialog } from "@headlessui/react";

import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function AssignAssemblyItemConfirmation(props) {
  const { sku, productName, confirmAction, setOpen, restoreListComponent } =
    props;

  const cancelButtonRef = useRef(null);

  const handleConfirm = () => {
    confirmAction();
  };

  const handleCancel = () => {
    if (restoreListComponent) {
      restoreListComponent();
    } else {
      setOpen({ childComponent: null, open: false });
    }
  };

  return (
    <div>
      <div>
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
          <ExclamationCircleIcon
            className="h-11 w-11 text-blue-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <Dialog.Title
            as="h3"
            className="text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Assign SKU to Product
          </Dialog.Title>
          <div className="mt-2">
            <p className="text-sm text-gray-500 family-didact">
              Do you want to assign {sku} to {productName}?
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center sm:grid sm:grid-flow-row-dense sm:grid-cols-2 gap-3">
        <div className="col-span-1 text-right">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
            onClick={handleCancel}
          >
            No
          </button>
        </div>
        <div className="col-span-1">
          <button
            type="button"
            className="inline-flex w-fit justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-light family-didact text-white shadow-sm hover:bg-indigo-600 col-span-1 sm:mt-0"
            onClick={handleConfirm}
            ref={cancelButtonRef}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
